import { useDispatch, useSelector } from "react-redux";
import { changeStatusNotices, onChangeIsEdit, onFetchNotices, onSetEditNotice, onSetOpenModal, onSetSelectedNotice, selectNoticeState } from "../redux/slices/noticeSlice";
import { ApiStatus } from "../types/api/status";
import { CustomSnackbar } from "../components/common/CustomSnackbar/CustomSnackbar";
import { NoticeAPI } from "../apis/NoticeAPI";
import { Notice, NoticeCreateEdit } from "../types/slices/noticesType";

export const useNoticeStore = () => {
  const dispatch = useDispatch();
  const {
    notices,
    statusNotices,
    editNotice,
    selectedNotice,
    openModal,
    isEdit,
  } = useSelector(selectNoticeState);

  const getNotices = async () => {
    try {
      dispatch(changeStatusNotices(ApiStatus.FETCHING));
      const response = await NoticeAPI.getNotices();
      if (!response?.status) {
        dispatch(changeStatusNotices(ApiStatus.FETCHED));
        return CustomSnackbar("error", response.data.message || "");
      }
      const { detail } = response.data;
      dispatch(onFetchNotices(detail));
      dispatch(changeStatusNotices(ApiStatus.FETCHED));
    } catch (error) {
      console.log(error);
      return dispatch(changeStatusNotices(ApiStatus.FETCHED));
    }
  };

  const getNoticesSearch = async (term) => {
    try {
      dispatch(changeStatusNotices(ApiStatus.FETCHING));
      const response = await NoticeAPI.getNoticesSearch(term);
      if (!response?.status) {
        dispatch(changeStatusNotices(ApiStatus.FETCHED));
        return CustomSnackbar("error", response.data.message || "");
      }
      const { detail } = response.data;
      dispatch(onFetchNotices(detail));
      dispatch(changeStatusNotices(ApiStatus.FETCHED));
    } catch (error) {
      console.log(error);
      return dispatch(changeStatusNotices(ApiStatus.FETCHED));
    }
  };

  const createNoticeStore = async (data: any) => {
    try {
      dispatch(changeStatusNotices(ApiStatus.FETCHING));
      const response = await NoticeAPI.createNotice(data);
      if (!response?.status) {
        dispatch(changeStatusNotices(ApiStatus.FETCHED));
        return CustomSnackbar("error", response.data.message || "");
      }
      dispatch(changeStatusNotices(ApiStatus.FETCHED));
      CustomSnackbar("success", response.data.message || "");
      return true;
    } catch (error) {
      console.log(error);
      return dispatch(changeStatusNotices(ApiStatus.FETCHED));
    }
  };

  const editNoticeStore = async (id: number, data: any) => {
    try {
      dispatch(changeStatusNotices(ApiStatus.FETCHING));
      const response = await NoticeAPI.editNotice(id, data);
      if (!response?.status) {
        dispatch(changeStatusNotices(ApiStatus.FETCHED));
        return CustomSnackbar("error", response.data.message || "");
      }
      dispatch(changeStatusNotices(ApiStatus.FETCHED));
      CustomSnackbar("success", response.data.message || "");
      return true;
    } catch (error) {
      console.log(error);
      return dispatch(changeStatusNotices(ApiStatus.FETCHED));
    }
  };

  const deleteNotice = async (id: number) => {
    try {
      dispatch(changeStatusNotices(ApiStatus.FETCHING));
      const response = await NoticeAPI.deleteNotice(id);
      if (!response?.status) {
        dispatch(changeStatusNotices(ApiStatus.FETCHED));
        CustomSnackbar("error", response.data.message || "");
        return false;
      }
      dispatch(changeStatusNotices(ApiStatus.FETCHED));
      CustomSnackbar("success", response.data.message || "");
      return true;
    } catch (error) {
      console.log(error);
      return dispatch(changeStatusNotices(ApiStatus.FETCHED));
    }
  };

  const setSelectedNotice = (notice: Notice) => {
    try {
      dispatch(onSetSelectedNotice(notice));
    } catch (error) {
      console.log(error);
    }
  };

  const setEditNotice = (notice: NoticeCreateEdit) => {
    try {
      dispatch(onSetEditNotice(notice));
    } catch (error) {
      console.log(error);
    }
  };

  const setOpenModal = (status: boolean) => {
    try {
      dispatch(onSetOpenModal(status));
    } catch (error) {
      console.log(error);
    }
  };

  const changeIsEdit = (status: boolean) => {
    try {
      dispatch(onChangeIsEdit(status));
    } catch (error) {
      console.log(error);
    }
  };

  return {
    // states
    notices,
    statusNotices,
    editNotice,
    selectedNotice,
    openModal,
    isEdit,
    // actions
    getNotices,
    getNoticesSearch,
    createNoticeStore,
    editNoticeStore,
    deleteNotice,
    setOpenModal,
    setEditNotice,
    setSelectedNotice,
    changeIsEdit,
  };
};